import React from "react"
import {  RaisedButton, IconButton, FontIcon } from "material-ui"
import FinddDatePicker from "../common/FinddDatePicker"
import moment from "moment"
import strings from "../../localization/strings"
import { blueGrey500 } from "material-ui/styles/colors"
import { EDayOfWeek, IDate } from "../../models"
import autobind from "class-autobind"
type CurrentButton = "today" | "next" | "last" | null
const styles = {
    ul: {
        margin: "0",
        paddingLeft: "20px"
    },
    root: {
        marginRight: "5px"
    },
    btn: {
        background: "white"
    },
    label: {
        fontSize: "14px"
    },
    activeBtn: {
        background: "#A9A9A9"
    },
    activeLabel: {
        color: "white"
    }
}
interface IProps {
    startDay: EDayOfWeek
    referenceDate: IDate
    getThisWeek(): void
    getLastWeek(): void
    handleChangeReferenceDate(date: IDate): void
}
interface IState {
    currentDate: IDate
    currentButton: CurrentButton
}

export default class DateButtonsRow extends React.Component<IProps, IState> {
    private FinddDatePicker
    constructor(props: IProps) {
        super(props)
        this.state = {
            currentButton: null,
            currentDate: moment().toDate()
        }
        autobind(this)
    }

    componentDidMount() {
        this.setCurrentButton(this.props.referenceDate)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.referenceDate !== nextProps.referenceDate &&
            this.setCurrentButton(nextProps.referenceDate)
    }

    setCurrentButton(referenceDate: IDate) {
        const startDayOfWeek1 = this.getStartDayOfWeek(this.state.currentDate)
        const startDayOfWeek2 = this.getStartDayOfWeek(referenceDate)
        const monday2WeekBack = moment(startDayOfWeek2).subtract(1, "week")
        const monday2WeekForth = moment(startDayOfWeek2).add(1, "week")
        const currentButton =
            moment(startDayOfWeek1).isSame(startDayOfWeek2, "day") ?
                "today" :
                moment(startDayOfWeek1).isSame(monday2WeekBack, "day") ?
                    "next" :
                    moment(startDayOfWeek1).isSame(monday2WeekForth, "day") ?
                        "last" : null
        this.setState({ currentButton })
    }

    getStartDayOfWeek(date: IDate) {
        const adjustedStartDay = this.props.startDay === 0 ? 7 : this.props.startDay
        return moment(date)
            .isoWeekday(adjustedStartDay)
            .subtract(moment(date).isoWeekday() >= adjustedStartDay ? 0 : 1, "week")
            .toDate()
    }

    handleClick(currentButton) {
        this.setState({ currentButton })
        currentButton === "today" ?
            this.props.getThisWeek() :
            this.props.getLastWeek()
    }

    getStyleLabel(type: CurrentButton) {
        return type === this.state.currentButton ?
            Object.assign({}, styles.label, styles.activeLabel) :
            styles.label
    }

    getStyleBtn(type: CurrentButton) {
        return type === this.state.currentButton ?
            Object.assign({}, styles.btn, styles.activeBtn) :
            styles.btn
    }

    render() {
        return (
            <div>
                <ul style={styles.ul}>
                    <RaisedButton
                        data-intercom-target={"Timecards-Btn-LastWeek"}
                        label={strings.Last_Week.toUpperCase()}
                        style={styles.root}
                        onTouchTap={() => this.handleClick("last")}
                        labelStyle={this.getStyleLabel("last")}
                        buttonStyle={this.getStyleBtn("last")}
                    />
                    <RaisedButton
                        data-intercom-target={"Timecards-Btn-ThisWeek"}
                        label={strings.This_Week.toUpperCase()}
                        style={styles.root}
                        onTouchTap={() => this.handleClick("today")}
                        labelStyle={this.getStyleLabel("today")}
                        buttonStyle={this.getStyleBtn("today")}
                    />
                    <IconButton
                        data-intercom-target={"Timecards-Btn-PickDate"}
                        tooltip={strings.Pick_a_date}
                        onTouchTap={() => this.FinddDatePicker.DatePicker.openDialog()}
                    >
                        <FontIcon className={"fa fa-calendar fa-lg"} />
                    </IconButton>
                </ul>
                <div>
                    <FinddDatePicker
                        ref={elem => (this.FinddDatePicker = elem)}
                        id={"dp-text-field"}
                        textFieldStyle={{ display: "none" }}
                        value={this.props.referenceDate}
                        onChange={(_, date) => this.props.handleChangeReferenceDate(date)}
                        cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                        firstDayOfWeek={0}
                    />
                </div>
            </div>
        )
    }
}


